import {isNullOrUndefined} from "../../../services/Validator";

export default function BrevetMediaIcon({icon, hasMedia, tooltip}) {
    // Used in BrevetLevelAMediaList to display one specific
    // available media for levelA

    // BUILD
    if (isNullOrUndefined(icon))
        return null
    return (
        <div className="relative group">
            <div className={`select-none cursor-auto w-[32px] min-w-[32px] h-[32px] min-h-[32px] flex justify-center items-center rounded-full ${hasMedia ? 'bg-greenStar/30' : 'bg-greyLight3'}`}>
                <i className={`material-icons text-[16px] ${hasMedia ? "text-greenStar" : "text-greyLight7"}`}>
                    {icon}
                </i>
            </div>
            {/** TOOLTIP */}
            <div className="pointer-events-none absolute top-full left-1/2
                mt-[12px]
                -translate-x-1/2
                opacity-0 group-hover:opacity-100
                transition-opacity duration-200
                z-50">
                <div className="relative bg-greyLight3 rounded-[6px]">
                    <div className="absolute left-1/2 -translate-x-1/2 top-[-6px]
                       w-0 h-0
                       border-l-[6px] border-r-[6px] border-b-[6px]
                       border-l-transparent border-r-transparent
                       border-b-greyLight3"/>
                    <div className="px-[10px] py-[6px] text-[12px] text-white whitespace-nowrap">
                        {tooltip}
                    </div>
                </div>
            </div>
        </div>
    );
}